var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<section class=\"col-xs-12 service-info\"> <div class=\"col-sm-3 col-xs-12 image-wrapper\" class=\"image-wrapper\"> <img ng-src=\"{{ $ctrl.image }}\" alt=\"\"/> </div> <div class=\"col-md-8 col-xs-12\"> <h3>{{ $ctrl.name }}</h3> <p ng-repeat=\"date in $ctrl.dates\"> {{ date.begin }}\n<span ng-if=\"date.begin != date.end\"> &ndash; {{ date.end }} </span> </p> <p ng-bind-html=\"$ctrl.description\" style=\"white-space: pre-wrap\"></p> </div> </section>";
var id1="winresServiceInfo.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceInfo/winresServiceInfo.html
// module id = 452
// module chunks = 2